<template>
	<div class="slide" :style="slideStyle">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'GallerySlide',
	data() {
		return {
			id: null,
			index: 0
		}
	},
	computed: {
		slideStyle() {
			return {
				left: 100 * this.index + '%'
			}
		}
	},
	methods: {
		setIndex(index) {
			this.index = index
		}
	},
	mounted() {
		this.id = this.$parent.register(this)
	},
	beforeDestroy() {
		this.$parent.deregister(this.id)
	}
}
</script>

<style lang="scss" scoped>
.slide {
	position: absolute;
	width: 100%;
}
</style>
